import { useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router";
import { expireToken } from "src/redux/slices/promoter";
import { useDispatch } from "src/redux/store";

export default function useApp() {
    const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useIdleTimer({
        timeout: 1000 * 60 * 15, // 15 minutes
        onIdle: () => {
            if (localStorage.getItem('@cnPromoter-name') ||
                localStorage.getItem('@cnPromoter-accessToken') ||
                localStorage.getItem('@cnPromoter-refreshToken')
            ) {
                setShowSessionExpiredModal(true)
                dispatch(expireToken(localStorage.getItem('@cnPromoter-refreshToken') || ''))
                localStorage.removeItem('@cnPromoter-name');
                localStorage.removeItem('@cnPromoter-accessToken');
                localStorage.removeItem('@cnPromoter-refreshToken');
                navigate('/')
            }
        },
    })

    return {
        showSessionExpiredModal,
        setShowSessionExpiredModal
    }
}
